module.exports = __webpack_public_path__ + "img/csv.68495747.svg";